/**
 * @fileoverview Provide the native-button option in the shared action vocabulary. Callers own action execution, pending state, and permission decisions; `AppIcon.js` resolves icon identity. PrimeReact-backed callers use `AppPrimeButton.js`, which shares the same managed icons.
 */

import React from 'react';
import AppIcon from './AppIcon';

const variantStyles = {
  primary: { backgroundColor: 'var(--primary-color)', color: '#ffffff', border: '1px solid var(--primary-color)' },
  secondary: { backgroundColor: 'var(--surface-card)', color: 'var(--text-color)', border: '1px solid var(--surface-border)' },
  success: { backgroundColor: '#16a34a', color: '#ffffff', border: '1px solid #15803d' },
  info: { backgroundColor: '#0ea5e9', color: '#ffffff', border: '1px solid #0284c7' },
  danger: { backgroundColor: '#dc2626', color: '#ffffff', border: '1px solid #b91c1c' }
};

const baseStyle = {
  borderRadius: '6px',
  padding: '0.5rem 1rem',
  fontWeight: 600,
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontSize: '0.875rem',
  lineHeight: 1.5,
  transition: 'opacity 0.15s'
};



function AppButton({ label, icon, onClick, disabled, variant = 'primary', className, type = 'button', autoFocus, children, style: extraStyle, ...rest }) {
  return (
    <button
      type={type}
      className={className || ''}
      style={{
        ...baseStyle,
        ...variantStyles[variant],
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.6 : 1,
        ...extraStyle
      }}
      onClick={onClick}
      disabled={disabled}
      autoFocus={autoFocus}
      {...rest}
    >
      {icon && <AppIcon icon={icon} aria-hidden="true" />}
      {label && <span>{label}</span>}
      {children}
    </button>
  );
}

export default AppButton;
